import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pageTitle: "",
  sectionLinks: [], // [{ name: , link: }, {...}]
  globalSearch: {
    searchTerm: "",
    selectedOfficeId: null,
  },
};

const global = createSlice({
  name: "global",
  initialState,
  reducers: {
    setSectionHeader(state, action) {
      state.pageTitle = action.payload.pageTitle;
      state.sectionLinks = action.payload.sectionLinks || [];
    },
    setGlobalSearchTerm(state, action) {
      state.globalSearch.searchTerm = action.payload;
    },
    setGlobalSearchOffice(state, action) {
      state.globalSearch.selectedOfficeId = action.payload;
    },
    clearGlobalSearch(state) {
      state.globalSearch.searchTerm = "";
      state.globalSearch.selectedOfficeId = null;
    },
  },
});

export const { setSectionHeader, setGlobalSearchTerm, setGlobalSearchOffice, clearGlobalSearch } = global.actions;

export const pageTitleSelector = state => state.global.pageTitle;
export const sectionLinksSelector = state => state.global.sectionLinks;
export const globalSearchTermSelector = state => state.global.globalSearch.searchTerm;
export const globalSearchOfficeSelector = state => state.global.globalSearch.selectedOfficeId;

export const reducer = global.reducer;
